import { NavController, NavParams, App, ModalController, ViewController, ToastController, Content } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { AuthProvider } from '../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../providers/employeerh/employeerh';


@Component({
    selector: 'page-rh-interview',
    templateUrl: 'rh-interview.html',
})
export class RhInterviewPage implements OnInit {
    @ViewChild('content') pageTop: Content;

    // DOMVar
    interview: any = null;
    interviewId:any = null;
    currStep: number = 0;
    goals:any = null;
    hasSubmittedGoals: boolean = false;

    // Form vars
    storeAnswers: any = {};
    storeGoalAnswers: any = {};


    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public storageProvider: Storage,
        public app: App,
        public authProvider: AuthProvider,
        public employeeRhProvider: EmployeeRhProvider,
        public viewCtrl: ViewController,
        public toastCtrl: ToastController
    ) {
        this.interview = this.navParams.get('interview').categories;
        this.goals = this.navParams.get('interview').goals;
        this.interviewId = this.navParams.get('interview').interview_id;
    }

    ngOnInit() {
        this.loadDatas();
    }

    loadDatas() {
        // Init vars

        for(let goal of this.goals){
            this.storeGoalAnswers[goal.id] = {
                goal_id : goal.id,
                value_reached : null,
                value_comment : null
            }
        }

        for (let cat of this.interview[0]) {
            for (let question of cat.category_questions) {
                switch (question.answertype) {
                    case '1': // This question type only takes string answers
                        this.storeAnswers[question.id] = {
                            question_id: question.id,
                            interview_id: this.interviewId,
                            answer_type: 1,
                            answer_string: '',
                            answer_number: null,
                            answer_boolean: null
                        }
                        break;

                    case '2': // This question type only takes number answers
                        this.storeAnswers[question.id] = {
                            question_id: question.id,
                            interview_id: this.interviewId,
                            answer_type: 2,
                            answer_string: null,
                            answer_number: '',
                            answer_boolean: null
                        }
                        break;

                    case '3': // This question type only takes number answers
                        this.storeAnswers[question.id] = {
                            question_id: question.id,
                            interview_id: this.interviewId,
                            answer_type: 3,
                            answer_string: null,
                            answer_number: '',
                            answer_boolean: null
                        }
                        break;

                    case '4': // This question type only takes number answers
                        this.storeAnswers[question.id] = {
                            question_id: question.id,
                            interview_id: this.interviewId,
                            answer_type: 4,
                            answer_string: null,
                            answer_number: '',
                            answer_boolean: null
                        }
                        break;

                    case '5': // This question type only takes number answers
                        this.storeAnswers[question.id] = {
                            question_id: question.id,
                            interview_id: this.interviewId,
                            answer_type: 5,
                            answer_string: null,
                            answer_number: '',
                            answer_boolean: null
                        }
                        break;

                    case '6': // This question type takes boolean and string
                        this.storeAnswers[question.id] = {
                            question_id: question.id,
                            interview_id: this.interviewId,
                            answer_type: 6,
                            answer_string: '',
                            answer_number: null,
                            answer_boolean: '',
                        }
                        break;

                    case '7': // This question type only takes number answers
                        this.storeAnswers[question.id] = {
                            question_id: question.id,
                            interview_id: this.interviewId,
                            answer_type: 7,
                            answer_string: null,
                            answer_number: '',
                            answer_boolean: null,
                        }
                        break;

                    default:
                        break;
                }
            }
        }
    }

    changeCurrStep(goForward: boolean) {
        goForward == true ? this.currStep++ : this.currStep--;
        this.pageTop.scrollToTop();
    }


    // Function to format and store answers of each answertype
    setRangeAnswer(questionId, value, catIndex, questionIndex) {
        this.storeAnswers[questionId].answer_number = value
        this.interview[0][catIndex].category_questions.splice(questionIndex, 1)

        // If the first step is empty (because user answered all quizz, then we go to next step)
        if(this.interview[0][0].category_questions.length == 0 && this.currStep == 0){
            this.changeCurrStep(true)
        }
    }

    setRadioAnswer(questionId, value){
        this.storeAnswers[questionId].answer_number = value
    }

    setBooleanAnswer(questionId, value){
        this.storeAnswers[questionId].answer_boolean = value
    }

    // Function for goals 
    setGoalRadioAnswer(goalId, value){
        this.storeGoalAnswers[goalId].value_reached = value
    }

    confirmGoals(){
        this.hasSubmittedGoals = true;
    }

    // Submit
    submitAnswer(){
        const answers = this.storeAnswers;
        const goals = this.storeGoalAnswers;
        let payload = [];
        let goalAnswers = [];

        for (var key in answers) {
            payload.push(answers[key])
        }

        for(var key in goals){
            goalAnswers.push(goals[key])
        }

            this.employeeRhProvider.saveUserInterview(payload, goalAnswers).subscribe((res) => {
                if(res.success){
                    let toast = this.toastCtrl.create({ message: "Vos réponses ont été envoyées", duration: 6000, position: 'bottom'});
                    toast.present();
                    this.dismiss();
                }
            });



    }



    // Modal ctrl
    dismiss() {
        this.viewCtrl.dismiss();
    }


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-interview/rh-interview.ts